import { getAddress, pad, toHex, zeroAddress } from "viem"
import { z } from "zod"
import { isAddress } from "../utils"
import {
  ACCOUNT_MAIN_INDEX,
  ACCOUNT_MAX_SUB_INDEX,
  ACCOUNT_PAD_SIZE,
} from "./constants"
import type { AccountPropsType, SubAccountPropsType } from "./types"

export function getSubAccountId({ primary, subAccount }: AccountPropsType) {
  if (
    !isAddress(primary) ||
    primary === zeroAddress ||
    !isAddress(subAccount) ||
    subAccount === zeroAddress
  ) {
    return 0
  }

  const subAccountId = Number(
    BigInt(getAddress(primary)) ^ BigInt(getAddress(subAccount)),
  )
  if (isSubAccountId(subAccountId)) return subAccountId
  // Error path
  console.error(
    `[getSubAccountId] Invalid subAccountId primary: ${primary} subAccount: ${subAccount} subAccountId: ${subAccountId}`,
  )
  return 0
}

export function isSubAccount(props: AccountPropsType) {
  return getSubAccountId(props) < ACCOUNT_MAX_SUB_INDEX
}

export function isSubAccountId(
  subAccountId: SubAccountPropsType["subAccountId"],
) {
  const schema = z
    .number()
    .int()
    .nonnegative()
    .gte(ACCOUNT_MAIN_INDEX)
    .lt(ACCOUNT_MAX_SUB_INDEX)
    .refine((n) => !Number.isNaN(n), { message: "Must be a valid number" })

  const resp = schema.safeParse(subAccountId)
  if (resp.success) return true
  console.error(`[isSubAccountId] Invalid subAccountId value: ${subAccountId}`)
  return false
}

export function getSubAccount({ primary, subAccountId }: SubAccountPropsType) {
  if (!isSubAccountId(subAccountId)) {
    throw `[getSubAccount] invalid subAccountId: ${subAccountId}`
  }
  if (!isAddress(primary) || primary === zeroAddress) return zeroAddress
  return pad(toHex(BigInt(getAddress(primary)) ^ BigInt(subAccountId)), {
    size: ACCOUNT_PAD_SIZE,
  })
}
